import { useEffect } from 'react';
import { SUB_NAVIGATION_ID } from './constants';
import useWindowMinWidth from '../hooks/useWindowMinWidth';
import addCssUnit from '../utils/add-css-unit';
import getElementById from '../utils/get-element-by-id';
import useBreakpoint from './useBreakpoint';

/**
 * Custom hook for managing stacked behavior of a navigation element.
 *
 * @param {Object} options - The options for the hook.
 * @param {Object} options.currentElement - DOM Element.
 * @param {string|Object} [options.navIdOrRef=SUB_NAVIGATION_ID] - The ID or reference to the navigation element.
 */
const useStacked = ({
  currentElement,
  navIdOrRef = SUB_NAVIGATION_ID
}) => {
  const breakpoint = useBreakpoint();
  const [matchBreakpoint] = useWindowMinWidth(breakpoint);
  useEffect(() => {
    const el = currentElement;
    if (!el) return;
    if (matchBreakpoint) {
      el.dataset.stacked = false;
      el.style.bottom = '0';
      return;
    }
    const nav = typeof navIdOrRef === 'string' ? getElementById(navIdOrRef) : navIdOrRef?.current;
    if (nav) {
      // the default is only used on testing environment
      const {
        height
      } = nav.getBoundingClientRect() ?? {
        height: 80
      };
      el.dataset.stacked = true;
      el.style.bottom = addCssUnit(height);
    }
  }, [matchBreakpoint, currentElement, navIdOrRef]);
};
export default useStacked;
//# sourceMappingURL=useStacked.js.map